import React from 'react'

function CircularProgress() {
  return (
    <>
    
    <div className="col-4 col-md-2 mx-auto">
        <div className="spinner-block text-primary" role="status">
            <span className="sr-only">Cargando...</span>
        </div>
    </div>

    </>
  )
}

export default CircularProgress